import { CardPaymentsLayout } from './layout'
import { CardPaymentsRoutes } from './routes'

export const CardPaymentsNavigation = {
  Layout: CardPaymentsLayout,
  Routes: CardPaymentsRoutes,
}
